import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import logo from "../logo-leasein.png";

export default function Nav() {
  const { client } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setMenuOpen(false);

  return (
    <header className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
      <div className="nav__inner">
        <a href="#home" className="nav__logo" onClick={close}>
          <img src={logo} alt="LEASEIN — Leasing Operațional" />
        </a>
        <nav className={`nav__links ${menuOpen ? "open" : ""}`}>
          <a href="#avantaje" onClick={close}>Avantaje</a>
          <a href="#despre" onClick={close}>Despre</a>
          <Link to={client ? "/portal" : "/login"} className="nav__portal" onClick={close}>
            {client ? "Portalul meu" : "Cont client"}
          </Link>
          <a href="#contact" className="nav__cta" onClick={close}>
            Solicită ofertă
          </a>
        </nav>
        <button
          className="nav__burger"
          aria-label="Meniu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span></span><span></span><span></span>
        </button>
      </div>
    </header>
  );
}
